import { render, staticRenderFns } from "./bv-home-view.vue?vue&type=template&id=4ecec820&"
import script from "./bv-home-view.vue?vue&type=script&lang=js&"
export * from "./bv-home-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports